module.exports = __webpack_public_path__ + "img/logo_starbucks2.529027e8.png";